import { Divider } from '@mui/material'
import { useContext } from 'react'
import { AppStateContext } from '../../../state/AppProvider'
import styles from '../FormStepsLegacy.module.css'
import { getBooleanValue, getValue } from '../helpers'
import { LegacyDisplayField } from '../LegacyDisplayField'
import planningBasicsLegacyStyles from './PlanningBasicsLegacy.module.css'

export const PlanningBasicsLegacy = () => {
  const appStateContext = useContext(AppStateContext)
  const planningBasics = appStateContext?.state.currentChat?.extended_data?.experiment?.planning_basics

  return (
    <div className={styles.stepContainer}>
      <div className={planningBasicsLegacyStyles.firstFieldsContainer}>
        <LegacyDisplayField
          label="Updated By"
          value={getValue(planningBasics?.updated_by_name?.field_value)}
        />
        <LegacyDisplayField
          label="E@S Experiment"
          value={getBooleanValue(planningBasics?.is_e_at_s_experiment?.field_value)}
        />
        <LegacyDisplayField
          label="OU"
          value={getValue(planningBasics?.ou?.field_value)}
        />
      </div>
      <div className={planningBasicsLegacyStyles.firstFieldsContainer}>
        <LegacyDisplayField
          label="Country"
          value={getValue(planningBasics?.country?.field_value)}
        />
        <LegacyDisplayField
          label="DME and Resources Committed"
          value={getBooleanValue(planningBasics?.dme_and_resources_committed?.field_value)}
        />
        <LegacyDisplayField
          label="Methodology"
          value={getValue(planningBasics?.methodology?.field_value)}
        />
      </div>
      <div className={planningBasicsLegacyStyles.firstFieldsContainer}>
        <LegacyDisplayField
          label="Global Category Name"
          value={getValue(planningBasics?.global_category_name?.field_value)}
        />
        <LegacyDisplayField
          label="Brand"
          value={getValue(planningBasics?.brand?.field_value)}
        />
        <LegacyDisplayField
          label="GLA Strategic Priority"
          value={getValue(planningBasics?.application_area?.field_value)}
        />
      </div>
      <Divider className={styles.divider} />
      <LegacyDisplayField
        label="E@S GLA Question"
        value={getValue(planningBasics?.gla_question?.field_value)}
      />
      <div className={styles.fieldContainer4Grid}>
        <LegacyDisplayField
          label="Experiment Code"
          value={getValue(planningBasics?.experiment_code?.field_value)}
        />

        <LegacyDisplayField
          label="Experiment Phase: High Level"
          value={getValue(planningBasics?.experiment_phase_high_level?.field_value)}
        />

        <LegacyDisplayField
          label="Year"
          value={getValue(planningBasics?.year?.field_value)}
        />
        <LegacyDisplayField
          label="Quarter"
          value={getValue(planningBasics?.quarter?.field_value)}
        />
      </div>
      <LegacyDisplayField
        label="Action Statement"
        value={getValue(planningBasics?.action_statement?.field_value)}
      />
    </div>
  )
}
